<div class="mvd_container mvd_container--pdf">
    <div class="well">
        <h1>Account Balance for {{displayName}} ({{customerAccountDetail.customerAccountNumberId}}): {{newAccountBalance.toFixed(2) | dollar}} </h1>
        <p><b>Disbursement Request Complete</b></p>
        <p><b>Disbursement Request Number:</b> {{disbursementRequestId}}</p>

        <ul class="list--bulleted--content">
            <li>Payment will be mailed to <strong>{{customerAccountDetail.accountAddress.addressLine1}} <ng-container *ngIf="customerAccountDetail.accountAddress.addressLine2">, {{customerAccountDetail.accountAddress.addressLine2}}</ng-container>, {{customerAccountDetail.accountAddress.city}}, {{getValues(customerAccountDetail.accountAddress.jurisdictionId, states)}} {{customerAccountDetail.accountAddress.postalZipCode | zipCode}}</strong>.</li>
            <li>The customer will be notified when the check has been issued by email.</li>
        </ul>
    </div>
</div>
